import { changeDateWithFormat } from "../../utils/date";
import { convertPhoneValue } from "../../utils/common";

export const getSingleFromGroupRequest = ({ request, uuid }) => {
  return request?.data?.patients?.find((i) => i.uuid === uuid);
};

export const mapPatients = ({ request, visitTypes }) => {
  const allSymptoms = visitTypes?.reduce(
    (acc, curr) => [...acc, ...(curr.symptoms || [])],
    [],
  );
  const allPatients = (request.patients || [])
    .map((i) => {
      const info = i.patient_info || {};
      const item = {
        ...i,
        ...info,
        uuid: i.uuid,
        patient_uuid: info.uuid,
        date_of_birth: changeDateWithFormat(info.date_of_birth, true),
        phone_number: convertPhoneValue(info.phone_number, true),
        symptoms: (i.symptoms || [])
          .map((j) => allSymptoms.find((k) => k.uuid === j))
          .filter(Boolean),
        status_request: i.status,
      };
      delete item.patient_info;
      return item;
    })
    .sort((a, b) => (a.status || "").localeCompare(b.status || ""));
  return {
    ...request,
    visit_type: request.visit_type,
    client_user_info: {
      ...request.client_user_info,
      date_of_birth: changeDateWithFormat(
        request.client_user_info?.date_of_birth,
        true,
      ),
      phone_number: convertPhoneValue(
        request.client_user_info?.phone_number,
        true,
      ),
    },
    allPatients: allPatients,
    patients: allPatients.filter((i) => !i.is_deleted),
  };
};
